module.exports = __webpack_public_path__ + "img/beer_id-16.4575aeb6.png";